module.exports = "https://www.gc-qa.gnp.com.mx/cb299931206117a8805c9a8c65d136fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/menos.png
// module id = 985
// module chunks = 0 1